window.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(ScrollTrigger);
        
    sal({
        threshold: 0.5, // 元素进入视口多少比例触发动画
        once: true,     // 是否只触发一次
        animateClassName: 'sal-animate', // 动画类名
        disabledClassName: 'sal-disabled', // 禁用类名
        rootMargin: '0% 50%', // 触发区域调整
        
    });

     AOS.init({
      offset: -120,
      once: true,
      mirror: false,
      duration: 1200,
      anchorPlacement: 'top-center'
    });
	function strToCents(str) {
		if(!str) return 0;
		const clean = String(str).trim().replace(/,/g, "");
		return Math.round(parseFloat(clean) * 100);
	}
	function initOdometerAnim(wrapSelector = '.odometer-wrap', duration = 2000, threshold = 0.5) {
		const wraps = document.querySelectorAll(wrapSelector);
		if (!wraps.length) return;

		wraps.forEach(wrap => {
			const odometers = wrap.querySelectorAll('.odometer');
			if (!odometers.length) return;

			odometers.forEach(el => {
				const orgVal = el.dataset.target;
				const useThousands = el.dataset.format !== 'none';

				let od = null, targetVal = 0;
				if(orgVal && orgVal.indexOf(".") == -1) {
					// 整数
					targetVal = parseInt(el.dataset.target, 10) || 0;
					const format = useThousands ? '(,ddd)' : 'd';
					od = new Odometer({
						el: el,
						value: 0,
						format: format,
						duration: duration,
						theme: 'car' 
					});
				} else {
					// 小数
					targetVal = strToCents(el.dataset.target) / 100;
					const format = useThousands ? '(,ddd).dd' : 'd.dd';
					od = new Odometer({
						el: el,
						value: 0,
						format: format,
						duration: duration,
						theme: 'car' 
					});
				}

				// 可视区域触发动画
				const observer = new IntersectionObserver((entries, obs) => {
					entries.forEach(entry => {
					if (entry.isIntersecting) {
						od.update(targetVal);
						obs.disconnect();
					}
					});
				}, { threshold });

				observer.observe(el);
			});
		});
		
	}


	initOdometerAnim('.odometer-wrap', 2500, 0.5);

    
	function animateHeading(selector, delay = 100, threshold = 0.5) {
		const targets = document.querySelectorAll(selector);
		if (!targets.length) return;
		
		targets.forEach(target => {
			const ps = target.querySelectorAll('p');
			const elements = ps.length ? ps : [target]; 
		
			elements.forEach(ele => {
				const split = new SplitType(ele, { types: 'lines, words, chars' });
		
				split.lines.forEach(line => {
					const wrapper = document.createElement('div');
					wrapper.className = 'line-wrapper';
					line.replaceWith(wrapper);
					wrapper.appendChild(line);
				});

				requestAnimationFrame(() => {
					target.classList.add("ready");
				});
		
				const words = ele.querySelectorAll('.word');
		
				const observer = new IntersectionObserver((entries, obs) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							words.forEach((word, index) => {
								setTimeout(() => {
									word.classList.add('in-viewport');
								}, index * 100); 
							});
							obs.disconnect();
						}
					});
				}, { threshold: 0.5 });
		
				observer.observe(ele);
			});
		});
	
	}


	function numberAnimate() {
		document.querySelectorAll(".numer-animate").forEach(el => {
			const text = el.textContent.trim();
			el.innerHTML = text.split("").map(ch => `<span>${ch}</span>`).join("");
			const spans = el.querySelectorAll("span");

			// 初始状态
			gsap.set(spans, { yPercent: 100, opacity: 0 });

			// 用 IntersectionObserver 检查窗口可见
			const observer = new IntersectionObserver((entries, obs) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						const tl = gsap.timeline();
						tl.to(spans, {
							yPercent: 0,
							opacity: 1,
							duration: 1,
							ease: "power2.out",
							stagger: 0.05
							/*, onComplete: () => {
								if(el.classList.contains("noes2i-value-number")) { el.style.clipPath = "none"; }
							}*/
						}).call(() => { el.style.overflow = "visible";console.log("111"); }, null, 0.6);
						obs.unobserve(el); // 只触发一次
					}
				});
			}, {
				threshold: 0.15 // 元素进入视口 15% 时触发
			});

			observer.observe(el);
		});
	}

	function playVideo(){
		const body = $('body');

		function showVideo(videoSrc, trackConfigs) {
			let trackHtml = "";
			if(trackConfigs && trackConfigs.length > 0) {
				const t1HTML = `
							<track src="${trackConfigs[0].src}" kind="${trackConfigs[0].kind}" srclang="${trackConfigs[0].srclang}" label="${trackConfigs[0].label}" 
								mode="hidden">`;
				trackHtml += t1HTML;
			}
			if(trackConfigs && trackConfigs.length > 1) {
				const t2HTML = `
							<track src="${trackConfigs[1].src}" kind="${trackConfigs[1].kind}" srclang="${trackConfigs[1].srclang}" label="${trackConfigs[1].label}" 
								mode="hidden">`;
				trackHtml += t2HTML;
			}
			const videoHtml = `
				<div class="video-fixed">
					<div class="video-popover">
						<video muted controls autoplay loop>
							<source src="${videoSrc}" type="video/mp4">${trackHtml}
						</video>
					</div>
		
					<button class="video-popover-close fs-20 div-like">
						<svg aria-hidden="true" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2131" width="200" height="200"><path d="M895.156706 86.256941a30.177882 30.177882 0 0 1 42.767059-0.180706c11.745882 11.745882 11.745882 30.870588-0.180706 42.767059L128.843294 937.743059c-11.866353 11.866353-30.930824 12.047059-42.767059 0.180706-11.745882-11.745882-11.745882-30.870588 0.180706-42.767059L895.156706 86.256941z" fill="#000000" p-id="2132"></path><path d="M86.076235 86.076235c11.745882-11.745882 30.870588-11.745882 42.767059 0.180706l808.899765 808.899765c11.866353 11.866353 12.047059 30.930824 0.180706 42.767059-11.745882 11.745882-30.870588 11.745882-42.767059-0.180706L86.256941 128.843294a30.177882 30.177882 0 0 1-0.180706-42.767059z" fill="#000000" p-id="2133"></path><path d="M0 0h1024v1024H0z" fill="#FFF4F4" fill-opacity="0" p-id="2134"></path></svg>
					</button>
				</div>`;
	
			body.append(videoHtml);
			$('.video-fixed').fadeIn(200);
		}

		function closeVideo() {
			$('.video-fixed').fadeOut(200).remove();
		}

		body.on('click', '.js-video', function () {
			let videoSrc = $(this).data('pvideo');
			let cfg1 = { src: $(this).data('t1Src'), kind: $(this).data('t1Kind'), srclang: $(this).data('t1Srclang'), label: $(this).data('t1Label') };
			let cfg2 = { src: $(this).data('t2Src'), kind: $(this).data('t2Kind'), srclang: $(this).data('t2Srclang'), label: $(this).data('t2Label') };
			if( $(window).width() < 1025 ){
				videoSrc = $(this).data('mvideo');
				cfg1 = { src: $(this).data('t1mSrc'), kind: $(this).data('t1Kind'), srclang: $(this).data('t1mSrclang'), label: $(this).data('t1mLabel') };
				cfg2 = { src: $(this).data('t2mSrc'), kind: $(this).data('t2Kind'), srclang: $(this).data('t2mSrclang'), label: $(this).data('t2mLabel') };
			}
			if (!videoSrc) return;
			showVideo(videoSrc, [cfg1, cfg2]);
		});
	
		body.on('click', '.video-popover-close', closeVideo);
	}

	function initFullscreenVideos() {
		const videos = document.querySelectorAll(".fullscreen-video");
		const isPc = window.innerWidth > 1024;

		videos.forEach(video => {
			const pcSrc = video.getAttribute("data-pc-video");
			const mobSrc = video.getAttribute("data-mobile-video");

			if (!pcSrc && !mobSrc) return;

			// 创建 source
			const source = document.createElement("source");
			source.src = isPc ? pcSrc : mobSrc;
			source.type = "video/mp4";

			// 清空旧的 <source>，避免重复
			video.innerHTML = "";
			video.appendChild(source);

			// 加载并播放
			video.load();
			video.play().catch(err => {
				console.warn("自动播放被阻止，需要用户交互:", err);
			});
		});
	}

	function cleanSectionAnimation() {
		if ($(window).width() < 1025) return;

		const $pic = $('.noes2i-clean-pic');
		const $sectionWrap = $('.noes2i-clean-wrap');
		const $section = $('.noes2i-clean');
		const $place = $('.noes2i-clean-header .item-place');
		const $mobileImg = $('.noes2i-clean-mobile');

		if (!$pic.length || !$section.length || !$place.length || !$mobileImg.length) return;

		const placeRect = $place[0].getBoundingClientRect();
		const sectionRect = $section[0].getBoundingClientRect();
		const x = placeRect.left - sectionRect.left;
		const y = placeRect.top - sectionRect.top;	
		const dWidth = $place.outerWidth();
		const dHeight = $place.outerHeight();
		const imgWidth = $mobileImg.outerWidth();
		const imgHeight = $mobileImg.outerHeight();
		// $('.noes2i-clean').css({'max-height': imgHeight + 'px'})
		// $('.noes2i-clean').css({'max-height':  '100vh'})
		// 设置初始位置与大小
		gsap.set($pic, {
			left: x,
			top: y,
			opacity: 1,
			width: dWidth,
			height: dHeight,
		});

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: '.noes2i-clean-wrap',
				start: 'top center',
				end: '+=90% center',
				scrub: 0.8,
				markers: false
			}
		});

		tl.fromTo('.noes2i-clean-rows',
			{ opacity: 0, y: 80 },
			{ opacity: 1, y: 0, ease: 'power3.out', duration: 1 },
			'+=0.5' 
		);

		// 背景淡出
		tl.to('.noes2i-clean-opa',
			{ opacity: 0, ease: 'power2.out', duration: 1 },
			'>-0.2'
		);

		tl.to($pic, {
			left: 0,
			// top: 0,
			top: sectionRect.height - imgHeight,
			width: imgWidth,
			height: imgHeight,
			ease: 'power2.out',
			duration: 1.2
		}, '>-0.1');

	}

	function travelSectionAnimate(){
		const section = document.querySelector(".noes2i-travel");
		if (!section) return;
		const images = section.querySelectorAll(".noes2i-travel-media img");
		const columns = section.querySelectorAll(".noes2i-travel-column");

		const num = Math.max(images.length, columns.length);

		const sticky = document.querySelector('.noes2i-travel-sticky');

		function updateStickyPosition() {
			const sectionHeight = section.offsetHeight;
			const stickyHeight = sticky.offsetHeight;
			const topValue = (window.innerHeight - stickyHeight) / 2;
			sticky.style.top = `${topValue}px`;
		}

		window.addEventListener('resize', updateStickyPosition);
		window.addEventListener('load', updateStickyPosition);


		ScrollTrigger.create({
			trigger: section,
			start: "top top",
			end: "bottom bottom",
			scrub: true,
			// markers: true,
			// pin: '.noes2i-travel-sticky',
			onUpdate: (self) => {
				const progress = self.progress;
				const effectiveProgress = progress * (1 / 0.9);
				const index = Math.min(Math.floor(effectiveProgress * num), num - 1);
				images.forEach((img, idx) => img.classList.toggle("active", idx === index));
				// columns.forEach((col, idx) => col.classList.toggle("active", idx === index));
				columns.forEach((col, idx) => {
					col.classList.toggle("active", idx === index);
					if(idx === index) {
						col.removeAttribute('aria-hidden');
						col.removeAttribute('aria-disabled');
						col.querySelector('.item-title')?.removeAttribute('role');
					} else {
						col.setAttribute('aria-hidden', 'true');
						col.setAttribute('aria-disabled', 'true');
						col.querySelector('.item-title')?.setAttribute('role', 'presentation');
					}
				});
			},
		});
	}

	function stackSliderInit() {
		const slider = document.querySelector('.noes2i-feel-slider');
		if (!slider) return;

		const slides = slider.querySelectorAll('.stack-slide');
		const total = slides.length;
		let current = 0;

		function getY(offsetVw) {
			const npx2vw = parseFloat(getComputedStyle(document.body).getPropertyValue('--npx2vw')) || 1;
			const vw = window.innerWidth;
			return (vw * offsetVw / 100) / npx2vw;
		}

		function getStackValues(index, isMobile) {
			const y1 = isMobile ? getY(120) : getY(160);
			const y2 = isMobile ? getY(220) : getY(280);

			switch (index) {
				case 0: return { y: 0, scale: 1, opacity: 1, z: 3 };
				case 1: return { y: y1, scale: 0.84, opacity: 0.7, z: 2 };
				case 2: return { y: y2, scale: 0.7, opacity: 0.3, z: 1 };
				default: return { y: y2, scale: 0.7, opacity: 0, z: 0 };
			}
		}

		function updateStack(instant = false) {
			const isMobile = window.innerWidth <= 768;
			slides.forEach((slide, i) => {
				const diff = (i - current + total) % total;
				const { y, scale, opacity, z } = getStackValues(diff, isMobile);
				slide.style.zIndex = z;
				gsap.to(slide, {
					y, scale, opacity,
					duration: instant ? 0 : 0.8,
					ease: "power3.out"
				});
			});
		}

		function playLoop() {
			const tl = gsap.timeline({
				repeat: -1,
				defaults: { ease: "power2.inOut" }
			});

			for (let i = 0; i < total; i++) {
				tl.call(() => {
					current = (current + 1) % total;
					updateStack();
				}, null, "+=2"); // 1.2s一轮，可以根据节奏调整
			}
		}

		updateStack(true);
		playLoop();
	}
	

	function initEffectiveSwiper() {
		const $article = $('.noes2i-effective-article');
		const $images = $('.noes2i-effective-images');
		if (!$article.length || !$images.length) return;

		const articleSwiper = new Swiper('.noes2i-effective-article', {
			loop: false,
			effect: 'fade',
			fadeEffect: { crossFade: true },
		});

		const imageSwiper = new Swiper('.noes2i-effective-images', {
			loop: false,
			effect: 'fade',
			speed: 400,
			fadeEffect: { crossFade: true },
		});

		// 同步两个 Swiper
		articleSwiper.controller.control = imageSwiper;
		imageSwiper.controller.control = articleSwiper;

		// 垂直居中 sticky 内容
		function setStickyVerticallyCentered() {
			const sticky = document.querySelector('.noes2i-effective-sticky');
			if (!sticky) return;
			const top = (window.innerHeight - $('.noes2i-effective-content').outerHeight()) / 2;
			sticky.style.top = `${top}px`;
		}

		setStickyVerticallyCentered();
		window.addEventListener('resize', setStickyVerticallyCentered);

		// 滚动控制逻辑
		const section = document.querySelector('.noes2i-effective');
		const dots = document.querySelectorAll('.noes2i-effective-progress .item-dot');
		const num = dots.length;
		if (!num || !section) return;

		let sectionTop = 0;
		let sectionHeight = 0;

		// 提前 10% 停止动画
		const endProgress = 0.5; // 动画占滚动总高度的 90%

		function updateSectionBounds() {
			const rect = section.getBoundingClientRect();
			const scrollY = window.scrollY || window.pageYOffset;
			sectionTop = rect.top + scrollY;
			sectionHeight = section.offsetHeight;
		}

		let lastIndex = -1;
		let ticking = false;

		function updateSwiperOnScroll() {
			const scrollY = window.scrollY || window.pageYOffset;
			// 限制滚动范围（0 → 0.9）
			let rawProgress = (scrollY - sectionTop) / (sectionHeight * endProgress);
			const progress = Math.min(Math.max(rawProgress, 0), 1);
			// const index = Math.floor(progress * num);
			const index = Math.min(Math.floor(progress * num), num - 1);
			if (index !== lastIndex) {
			lastIndex = index;
			imageSwiper.slideTo(index, 300);
			dots.forEach((dot, i) => dot.classList.toggle('active', i === index));
			}

			ticking = false;
		}

		function onScroll() {
			if (!ticking) {
			requestAnimationFrame(updateSwiperOnScroll);
			ticking = true;
			}
		}

		// 点击 dot 切换
		dots.forEach((dot, i) => {
			dot.addEventListener('click', () => {
			imageSwiper.slideTo(i, 400);
			dots.forEach((d, idx) => d.classList.toggle('active', idx === i));
			});
		});

		function initAndListen() {
			updateSectionBounds();
			updateSwiperOnScroll();
		}

		window.addEventListener('scroll', onScroll);
		window.addEventListener('resize', updateSectionBounds);

		initAndListen();
	}

	function initDifferentSwiper() {
		const mediaEl = document.querySelector('.noes2i-different-media');
		const articleEl = document.querySelector('.noes2i-different-article');
		const dots = document.querySelectorAll('.noes2i-different-dot');
		const paths = document.querySelectorAll('.progress-path');

		if (!mediaEl || !articleEl || !dots.length) return;

		// 初始化两个 Swiper
		const imageSwiper = new Swiper('.noes2i-different-media', {
			loop: false,
			effect: 'fade',
			fadeEffect: { crossFade: true },
		});

		const articleSwiper = new Swiper('.noes2i-different-article', {
			loop: false,
			effect: 'fade',
			fadeEffect: { crossFade: true },
		});

		// 互相控制
		imageSwiper.controller.control = articleSwiper;
		articleSwiper.controller.control = imageSwiper;

		let pathTween = null;

		// 播放进度环动画
		function animatePath(index) {
			if (!paths.length) return;
			if (pathTween) pathTween.kill();

			// 重置所有 path
			gsap.set(paths, { strokeDashoffset: 307 });

			// 播放当前 path
			const currentPath = paths[index];
			if (currentPath) {
			pathTween = gsap.to(currentPath, {
				strokeDashoffset: 0,
				duration: 1.2,
				ease: 'linear',
			});
			}
		}

		// 设置激活的 dot
		function setActiveDot(index) {
			dots.forEach((dot, i) => dot.classList.toggle('active', i === index));
		}

		// 初始化第一个
		setActiveDot(0);
		animatePath(0);

		// Swiper 切换时更新 dot 和动画
		imageSwiper.on('slideChange', () => {
			const index = imageSwiper.realIndex;
			setActiveDot(index);
			animatePath(index);
		});

		// 点击 dot 切换
		dots.forEach((dot, i) => {
			dot.addEventListener('click', () => {
			imageSwiper.slideTo(i);
			setActiveDot(i);
			animatePath(i);
			});
			if(window.handleKeyPress2026_v1) {
				window.handleKeyPress2026_v1(dot, function(){ $(dot).trigger('click') });
			}
		});
	}

	if( $('.noes2i-hear-swiper').length ){
		if ($('.noes2i-hear-swiper').length) {
			const hearSwiper = new Swiper('.noes2i-hear-swiper', {
				loop: true,
				centeredSlides: true,
				slidesPerView: 'auto',
				effect: 'coverflow',
				coverflowEffect: {
					rotate: 0,
					stretch: 120,
					depth: 285,
					modifier: 1,
					slideShadows: false,
				},
				navigation: {
					nextEl: '.noes2i-hear-next',
					prevEl: '.noes2i-hear-prev',
				},
				autoplay: {
					delay: 4000,
					disableOnInteraction: false,
				},
				breakpoints: {
					1024: {
						coverflowEffect: {
						stretch: 0,
						},
					},
				}
			});

		}
	}

	function syncUseContentHeight(){
		$('.noes2u-use-v2').each(function(){
			const $section = $(this);
			const $content = $section.find('.noes2u-use-content').first();
			const $items = $content.find('.noes2u-use-item');
			if (!$content.length || !$items.length) return;

			if (window.innerWidth <= 768) {
				$content.css('min-height', '');
				return;
			}

			let maxHeight = 0;
			$items.each(function(){
				const $item = $(this);
				const previousStyle = $item.attr('style');
				if ($item.css('display') === 'none') {
					$item.css({
						display: 'block',
						visibility: 'hidden'
					});
				}
				maxHeight = Math.max(maxHeight, this.getBoundingClientRect().height);
				if (previousStyle === undefined) {
					$item.removeAttr('style');
				} else {
					$item.attr('style', previousStyle);
				}
			});

			if (maxHeight) {
				$content.css('min-height', `${Math.ceil(maxHeight)}px`);
			}
		});
	}

	syncUseContentHeight();
	$(window).on('load resize orientationchange', syncUseContentHeight);

	$('.noes2u-use-tab li').on('click', function(){
		$(this).addClass('active').siblings().removeClass('active');
		$('.noes2u-use-item').eq($(this).index()).fadeIn().siblings().hide();
		$(this).attr('aria-selected','true').siblings().attr('aria-selected','false');
		syncUseContentHeight();

	})
	if(window.handleKeyPress2026_v1) {
		$('.noes2u-use-tab li').each(function(idx, el){ window.handleKeyPress2026_v1(el, function(){ $(el).trigger('click') }); });
	}


	playVideo();
	initFullscreenVideos();
	travelSectionAnimate();
	numberAnimate();
	stackSliderInit();
	initEffectiveSwiper();
	initDifferentSwiper();
	animateHeading('.animatedHeading', 100, 0.5);
	window.addEventListener("load", () => {
		ScrollTrigger.refresh();
		cleanSectionAnimation();
	});
});



